import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { mediaList } from "@/mocks/media";

const heroIds = ["1", "13", "3", "15", "4"];
const slides = mediaList.filter((m) => heroIds.includes(m.id));

export default function HomeHero() {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (paused) return;
    const timer = setInterval(() => {
      setIndex((i) => (i + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [paused]);

  const prev = () => setIndex((i) => (i - 1 + slides.length) % slides.length);
  const next = () => setIndex((i) => (i + 1) % slides.length);
  const active = slides[index];

  if (!active) return null;

  return (
    <section
      className="relative h-[420px] w-full overflow-hidden bg-primary-950 md:h-[600px]"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <div className="absolute inset-0">
        <img
          src={active.backdrop}
          alt={`${active.title} 剧照`}
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-950/90 via-primary-950/70 to-primary-950/30"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-primary-950/80 via-transparent to-primary-950/40"></div>
      </div>

      <div className="relative z-10 mx-auto flex h-full w-full max-w-[1440px] flex-col justify-center px-4 md:px-8">
        <div key={active.id} className="max-w-2xl animate-fade-up">
          <div className="mb-3 flex flex-wrap items-center gap-2 text-xs">
            <span className="rounded-md bg-accent-500 px-2 py-1 font-bold text-primary-950">
              {active.type === "movie" ? "热映电影" : "热播剧集"}
            </span>
            <span className="flex items-center gap-1 rounded-md bg-background-50/15 px-2 py-1 font-medium text-background-50 backdrop-blur-sm">
              <i className="ri-star-fill text-accent-400"></i>
              {active.rating.toFixed(1)}
            </span>
            <span className="text-background-100">{active.year}</span>
            <span className="text-background-200">{active.region}</span>
          </div>

          <h1 className="font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl">
            {active.title}
          </h1>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-background-100 md:text-base">
            {active.synopsis}
          </p>

          <div className="mt-6 flex flex-wrap items-center gap-3">
            <Link
              to={`/detail/${active.id}`}
              className="flex items-center gap-2 rounded-md bg-accent-500 px-5 py-2.5 text-sm font-bold text-primary-950 transition-colors hover:bg-accent-400 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-play-circle-line text-lg"></i>
              查看详情
            </Link>
            <Link
              to={active.type === "movie" ? "/category/movie" : "/category/tv"}
              className="rounded-md border border-background-50/40 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10 cursor-pointer whitespace-nowrap"
            >
              浏览更多{active.type === "movie" ? "电影" : "电视剧"}
            </Link>
          </div>
        </div>
      </div>

      <button
        type="button"
        aria-label="上一张"
        onClick={prev}
        className="absolute left-3 top-1/2 z-20 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full bg-primary-950/50 text-background-50 backdrop-blur-sm transition-colors hover:bg-accent-500 hover:text-primary-950 md:left-6 md:h-10 md:w-10 cursor-pointer"
      >
        <i className="ri-arrow-left-s-line text-xl"></i>
      </button>
      <button
        type="button"
        aria-label="下一张"
        onClick={next}
        className="absolute right-3 top-1/2 z-20 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full bg-primary-950/50 text-background-50 backdrop-blur-sm transition-colors hover:bg-accent-500 hover:text-primary-950 md:right-6 md:h-10 md:w-10 cursor-pointer"
      >
        <i className="ri-arrow-right-s-line text-xl"></i>
      </button>

      <div className="absolute bottom-5 left-1/2 z-20 flex -translate-x-1/2 items-center gap-2">
        {slides.map((s, i) => (
          <button
            key={s.id}
            type="button"
            aria-label={`切换到第 ${i + 1} 张`}
            onClick={() => setIndex(i)}
            className={`h-1.5 rounded-full transition-all cursor-pointer ${
              i === index ? "w-8 bg-accent-500" : "w-3 bg-background-50/50"
            }`}
          />
        ))}
      </div>
    </section>
  );
}